import OpenedLockIcon from './component'

export default OpenedLockIcon
